import PwaDiagnosticLogController from "./pwa/diagnostic_log_controller"
import db from "../chat_db"

// Chat app diagnostic log -- extends shared base with chat_db.
export default class extends PwaDiagnosticLogController {
  get _db() { return db }
  get _tableName() { return "app_log" }
}
